import httpService from "@/utils/request";
import tokenService from "@/utils/tokenService";
import GlobalLoadingService from "@/utils/globalLoading";
import messageService from "@/utils/message";

const managementService = {

    getParkPageListByParams(params: any) {
        const url = "/operating/park/getParkPageListByParams";
        return httpService.post(url, params);
    },

    addPark(params: any) {
        const url = "/operating/park/createPark";
        return httpService.post(url, params);
    },

    editPark(params: any) {
        const url = "/operating/park/updatePark";
        return httpService.put(url, params);
    },

    delPark(id: any) {
        const url = "/operating/park/deletePark/"+id;
        return httpService.delete(url);
    },

    getParkList() {
        const url = "/operating/park/getParkList";
        return httpService.get(url);
    },

    getDevicePageListByParams(params: any) {
        const url = "/operating/assets/getPageAssetsBriefDtoByParams";
        return httpService.post(url, params);
    },

    getDeviceTypeListByParams(params: any) {
        const url = "/operating/assets/getAllAssetsType";
        return httpService.post(url, params);
    },

    addDevice(params: any) {
        const url = "/operating/assets/saveAssets";
        return httpService.post(url, params);
    },

    editDevice(params: any) {
        const url = "/operating/assets/updatePark";
        return httpService.post(url, params);
    },

    delDevice(id: any) {
        const url = "/operating/assets/deleteAssetsById?id="+id;
        return httpService.delete(url);
    },

    updateQRCode(id: any) {
        const url = "/operating/assets/updateQRCode?id="+id;
        return httpService.get(url);
    },

    getDeviceDetailById(id: any) {
        const url = "/operating/assets/getAssetsDetailById?id="+id;
        return httpService.get(url);
    },

    searchDeviceFixListByPage(params: any) {
        const url = "/operating/assets/getPageAssetsInspectionDtoByParams";
        return httpService.post(url, params);
    },

    addFixDetail(params: any) {
        const url = "/operating/assets/saveAssetsInspection";
        return httpService.post(url, params);
    },

    delFixDetailById(id: any) {
        const url = "/operating/assets/deleteAssetsInspectionById?id="+id;
        return httpService.delete(url);
    },


    getAttachFileList(params: any) {
        const url = "/operating/doc/getNewPageExclusiveDocumentDtoByParam";
        return httpService.post(url, params);
    },

    getAttachFileTypeList(id: any) {
        const url = "/operating/doc/getDocumentTypeByTableTypeId?tableTypeId="+id;
        return httpService.get(url);
    },

    deleteFile(id: any) {
        const url = "/operating/doc/deleteExclusiveFile/"+id;
        return httpService.delete(url);
    },

    downloadFile(id: any) {
        let st: any = tokenService.getToken();
        let url = process.env.VUE_APP_API_GATEWAY_BASE_URL+ "/doc/docExclusive/downloaddoc";
        // let url = process.env.VUE_APP_API_GATEWAY_BASE_URL+ "/operating/doc/downloadExclusiveFile";
        
        let myForm = document.createElement("form");
        myForm.method = "post";
        myForm.action = url;

        let tokenInput = document.createElement("input");
        tokenInput.setAttribute('name', 'token');
        tokenInput.setAttribute('value', st);
        myForm.appendChild(tokenInput);

        let idInput = document.createElement("input");
        idInput.setAttribute('name', 'docFileId');
        idInput.setAttribute('value', id);
        myForm.appendChild(idInput);

        myForm.target = "_blank";

        document.body.appendChild(myForm);

        myForm.submit();

        document.body.removeChild(myForm);
    },



    uploadFile (params: any) {

        let uploadUrl = '/operating/doc/uploadExclusiveFile';
        var formData = new FormData();
        formData.append('uploadedfile', params.file);
        formData.append("tableType", params.tableType);
        if(params.tableId){
            formData.append("tableId", params.tableId);
        }

        if(params.filename){
          formData.append("filename",params.filename)
        }else{
          formData.append("filename", params.file.name);
        }
        if(params.serviceId){
            formData.append("serviceId", params.serviceId+"");
        }else{
            formData.append("serviceId", 4 + "");
        }
        if(params.docClassId){
            formData.append("docClassId", params.docClassId+"");
        }
        if(params.parkId){
            formData.append("parkId", params.parkId+"");
        }

        if(params.fileType){
          formData.append("fileType", params.fileType);
        }else{
          formData.append("fileType", 0+"");
        }

        if(params.remark){
            formData.append("remark", params.remark);
        }

        if(params.id){
            formData.append("fileId",params.id)
        }



        const serviceTicket = tokenService.getToken();
        let config = {
            headers: {
              'Content-Type': 'multipart/form-data',
              'Authorization': serviceTicket
            },
            onUploadProgress:(progressEvent:any)=>{
                console.log(progressEvent);
                // switch (progressEvent.type) {
                //     case HttpEventType.Sent:
                //         return `开始上传文件`;
                //     // 正在上传
                //     case HttpEventType.UploadProgress:
                //         const percentDone = Math.round(100 * event.loaded / event.total);
                //         return `${percentDone}%`;
                //     // 上传完毕
                //     case HttpEventType.Response:
                //         // 回调
                //         successCallback(event.body['data']);
                //         return '文件上传完毕';
                //     default:
                //         return `文件上传`;
                // }
            }
        };

        return httpService.post(uploadUrl,formData,config);

    },

    getConstrucionSupervisorIndicatorList:(params:any)=>{
        const url = "/operating/doc/getPolicyAssemblyShowBox";
        return httpService.post(url, params);
    },

    getAssetsTemplateExcelFile:(param:any)=>{
        const url = "/operating/assets/downloadAssetsExcelTemplate";
        return httpService.post(url,param,{ responseType: 'blob' });
    },

    uploadAndAnalysis:(file:any, parkId:any,enterpriseId:any, successCallback: (data:any) => void) => {
        GlobalLoadingService.openLoading();
        let uploadUrl = '/operating/assets/uploadAndAnalysisExcelTemplate';

        var formData = new FormData();
        formData.append('uploadFile', file);
        formData.append('enterpriseId', enterpriseId);
        formData.append('parkId', parkId);

        const serviceTicket = tokenService.getToken;

        // let headers = new AxiosRequestConfig();
        // headers = headers.set('Authorization', serviceTicket);

        let config = {
            headers: {
              'Content-Type': 'multipart/form-data',
              'Authorization': serviceTicket
            },
            onUploadProgress:(progressEvent:any)=>{
                console.log("enterServiceUploadProgress-----------");
                if(progressEvent.loaded != progressEvent.total){
                    const percentDone = Math.round(100 * progressEvent.loaded / progressEvent.total);
                    return `${percentDone}%`;
                }
            }
        };

        httpService
            .post(uploadUrl,formData,config)
            .then(
                (event:any) => {
                    console.log(event);
                    successCallback(event)
                },
                (err:any) => {
                    console.log(err);
                    messageService.info('error', '提交失败');
                }
            )
            .finally(()=>{
                GlobalLoadingService.closeLoading();
            });
    },

    getAssetsExcelFile:(param:any) => {
        const url = "/operating/assets/getAssetsExcelFile";
        return httpService.post(url,param, {responseType: "blob"})
    },

    getUnlinkIotDeviceList:(param:any) =>{
        const url = "/operating/assets/getUnlinkIotDeviceList?parkId="+param;
        return httpService.get(url)
    },

    addIotDevice:(param:any) =>{
        const url = "/operating/assets/addIotDevice";
        return httpService.post(url,param)

    },
    downloadDeviceQrCode(params: any) {
        var st: any = tokenService.getToken();
        // var url = environment._api_gateway_bff_base_url + "/doc/downloadNormalFile";//调试不成功
        var url = process.env.VUE_APP_API_GATEWAY_BASE_URL + "/operating/assets/downloadAll";

        var myForm = document.createElement("form");
        myForm.method = "post";
        myForm.action = url;

        var tokenInput = document.createElement("input");
        tokenInput.setAttribute('name', 'token');
        tokenInput.setAttribute('value', st);
        myForm.appendChild(tokenInput);

        var paramInput = document.createElement("input");
        paramInput.setAttribute('name', 'scopeId');
        paramInput.setAttribute('value', params);
        myForm.appendChild(paramInput);

        myForm.target = "_blank";

        ////console.log(st);
        ////console.log(tokenInput.value);
        document.body.appendChild(myForm);

        console.log(myForm);

        myForm.submit();

        document.body.removeChild(myForm);
    },

    getMobileUserPageListByParams:(param:any) =>{
        const url = "/operating/Mobile-user/getMobileUserPageListByParams";
        return httpService.post(url,param)

    },

    deleteMobileUser:(id:any) =>{
        const url = "/operating/Mobile-user/deleteMobileUser/"+id;
        return httpService.delete(url)

    },

    updateByMobileUserId:(param:any) =>{
        const url = "/operating/Mobile-user/updateByMobileUserId";
        return httpService.put(url,param)

    },

    getUserList:() =>{
        const url = "/admin/user/getSysUserBindDtoList";
        return httpService.get(url)

    },

    getWxAppPageListByParams:(params: any) =>{
        const url = "/operating/wx-app/getWxAppPageListByParams";
        return httpService.post(url,params)

    },

}


export default managementService;
